import {
	CURRENCY_ERROR,
	CURRENCY_RECEIVE,
	CURRENCY_REQUEST,
	SET_CURRENCY,
	SET_TIMEZONE,
	SET_LANGUAGE, TIMEZONES_REQUEST, TIMEZONES_RECEIVE, TIMEZONES_ERROR, START_BUTTON, SET_VERSION, SET_FIRST_TIME
} from './SettingsAction'

const initialState = {
	currencies: [],
	languages: [],
	timezones: [],
	language: 'en',
	currency: 'Rial',
	timezone: 'Asia/Tehran',
	startButton: false,
	version: null,
	firstTime: true
}

const SettingsReducer = (state = initialState, action = {}) => {
	const {
		type,
		error,
		currencies,
		timezones,
		language,
		currency,
		timezone,
		version
	} = action

	switch (type) {

		// ------------------------------------ currency fetch ------------------------------------
		case CURRENCY_REQUEST:
			return {
				...state,
				isCurrencyFetching: true
			}
		case CURRENCY_RECEIVE:
			return {
				...state,
				isCurrencyFetching: false,
				currencies
			}
		case CURRENCY_ERROR:
			return {
				...state,
				isCurrencyFetching: false,
				error
			}

		// ------------------------------------ timezones fetch ------------------------------------
		case TIMEZONES_REQUEST:
			return {
				...state,
				isTimezonesFetching: true
			}
		case TIMEZONES_RECEIVE:
			return {
				...state,
				isTimezonesFetching: false,
				timezones
			}
		case TIMEZONES_ERROR:
			return {
				...state,
				isTimezonesFetching: false,
				error
			}

		case SET_FIRST_TIME:
			return {
				...state,
				firstTime: false
			}

		case SET_CURRENCY:
			return {
				...state,
				currency
			}

		case SET_LANGUAGE:
			return {
				...state,
				language
			}
		case SET_TIMEZONE:
			return {
				...state,
				timezone
			}
		case SET_VERSION:
			return {
				...state,
				version
			}

		case START_BUTTON:
			return {
				...state,
				startButton: true
			}

		default:
			return state
	}
}

export default SettingsReducer
